import { Injectable } from "@angular/core";
import pdfMake from 'pdfmake/build/pdfmake';
import {  DocumentBase, DocumentDataType, LanguageService, Mandant, PageFormatService, UserAuthService, UserBase, WebFrameworkService, PDFDruckService as WebPDFDruckService } from "@definitiv-packages/angular-dba-library";
import { SafetyPointModelView } from "../types/safety-point-model";
import { SafetyPointFormModelView } from "../types/SafetyPointFormModel";
import { Content, ContentText, Table, TableCell, TDocumentDefinitions } from "pdfmake/interfaces";
import { ProjectLanguage } from "../types/ProjectLanguage";
import { DocumentAuthService, DocumentService, Quality } from "@definitiv-packages/angular-documents-library";
import { DatePipe } from "@angular/common";
import { CompletedFormDto, CompletedFormModel, FormFieldTypeEnum } from "@definitiv-packages/angular-forms-library";
import { DocumentDataType as datatype } from "../types/document-data-type-enum";
@Injectable({
    providedIn: 'root'
})
export class SafetypointPDFService extends WebPDFDruckService {
    public language: ProjectLanguage = new ProjectLanguage();
    private UserList: UserBase[] = [];
    constructor(
      private documentService: DocumentAuthService,
      framework: WebFrameworkService,
      private datePipe: DatePipe,
      public languageService: LanguageService,
       private dokumenteService : DocumentService,
      private userauthService: UserAuthService,
      page: PageFormatService
    ) {
      super(framework, page);
      this.language = this.languageService.getLanguageAsSetter();
    }
    public async generateAuditsPDF(safetypoint: SafetyPointModelView,safetypointformList: SafetyPointFormModelView[], mandant: Mandant,  completdForms :CompletedFormDto[],formfelderlist:any[]): Promise<string> {
    this.UserList = await this.userauthService.GetAppUserBaseList();
    
    var docDefinition = await this.generateAuditsPdfDocDefinition(safetypoint,safetypointformList,mandant,completdForms,formfelderlist);
    return new Promise<string>(async (resolve) => {
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getBase64((data) => {
        resolve(data);
      });
    });
  }
  async generateAuditsPdfDocDefinition( safetypoint: SafetyPointModelView,safetypointformList:SafetyPointFormModelView[] , mandant: Mandant, completdForms :CompletedFormDto[],formfelderlist:any[]): Promise<TDocumentDefinitions>{
      var mandantImage = await this.documentService.getFirstImageString(
        DocumentDataType.Mandant,
        mandant.MandantID,
        Quality.Full
      );    
      var dokumente = await this.dokumenteService.getFilteredList({DataTypeID: datatype.SafetyPoint, DataID: safetypoint.SafetyPointId});
     if(!mandantImage)mandantImage = this.GetWhiteImage();
      var mainBody : any[]=[];
      var today = this.datePipe.transform(new Date(),"dd.MM.yyy HH.mm")
      
      const stack1 ={ 
          stack:[
              {
                  columns:[
                    {
                        text: "Details zum Sicherungspunkt: ",
                        alignment: 'left',
                        margin: [0, 0, 0, 0],
                        decoration: 'underline'
                    }
                  ]
            }                            
      ]  
    }
    mainBody.push(JSON.parse(JSON.stringify(stack1)));

      const details: any = {
          margin: [0, 20, 20, 20],
          table: {
            widths: ['auto', '*'],
            body: [
                    [
                        {text:this.languageService.getText(this.language.objekt)},{text:": "+safetypoint.ObjektBezeichnung}
                    ],
                    [
                        {text:this.languageService.getText(this.language.Standort)},{text:": "+safetypoint.StandortBezeichnung}
                    ],
                    [
                        {text:this.languageService.getText(this.language.roofarea)},{text:": "+safetypoint.RoofareaBezeichnung}
                    ],
                    [
                        {text:this.languageService.getText(this.language.Sicherungssystem)},{text:": "+safetypoint.SicherungssystemBezeichnung}
                    ]
            ]
          },
          layout: {
            hLineWidth: function () { return 0; },
            vLineWidth: function () { return 0; }
          }
      }
      mainBody.push(details)
      
      dokumente.forEach(dokument=>{

          let metaString = "";                
          if(dokument.MetaData){
              var metaObj = JSON.parse(dokument.MetaData);
              if(metaObj.CreatedOn){
                  metaString = this.languageService.getText(this.language.Erstellt)+": "+ this.datePipe.transform(new Date(metaObj.CreatedOn),"dd.MM.yyyy HH:mm");
              }
          }     

          let cols = [];
          let src = dokument.Src.toString(); 
          var c3 = {
                stack :[                           
                    {
                        columns:[
                          {
                              image: src,
                              fit: [200, 200],
                              alignment: 'left',
                              margin: [0, 15, 0, 5]
                          }
                        ]
                    },
                    {
                        columns:[
                          {
                              text: metaString,
                              alignment: 'left',
                              margin: [0, 5, 0, 5],
                              fontSize:9
                          }
                        ]
                    }                          
                ], 
                unbreakable: true
              }
              c3 = JSON.parse(JSON.stringify(c3));
              cols.push(c3);
              mainBody.push({ columns: cols });
        })

      var latutude = this.languageService.getText(this.language.Latitude)+": "+ safetypoint.Latitude;
      var longitude = this.languageService.getText(this.language.Longitude)+": "+ safetypoint.Longitude;
      var title = this.languageService.getText(this.language.Audit)+": "+ safetypoint.Bezeichnung;
      
      const break1: Content = {
          text: '', pageBreak: 'after'
      }
      mainBody.push(break1)
      for (let index = 0; index < safetypointformList.length; index++) {
        var elem = safetypointformList[index];
        
          var completdForm = completdForms.find(x=>x.CompletedFormId == elem.CompletedFormId);
      
          const  o  = await this.generateAudits(elem, completdForm!,formfelderlist)
          mainBody.push(o)
          
          if(index < safetypointformList.length-1){
              const break2: Content = {
                  text: '', pageBreak: 'after'
              }
              mainBody.push(break2)
          }
      }

      const docDefinition: TDocumentDefinitions = {
      pageMargins: [30, 100, 20, 60],
      header:  (currentPage, pageCount, pageSize) =>({
          style: 'header',
          columns: [
            {
              table: {
                widths: ['*', 100],
                body: [
                  [
                    { text: title, style: 'header' },
                    {image: mandantImage,fit: [120, 60],alignment: 'right',rowSpan: 2},
                  ],
                  [
                    {
                      text:  latutude+"\n "+longitude ,
                      style: 'subheader',
                    },
                  ],
                ],
              },
              layout: 'noBorders'
            }
          ],
          margin: [30, 30, 20, 0],
      } as Content),
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                text: 'gedruckt am ' + today,
                alignment: 'left',
                margin: [70, 0, 0, 0],
                style: 'footer',
              },
              {
                text: 'Seite ' + currentPage.toString() + ' von ' + pageCount,
                alignment: 'right',
                style: 'footer',
              },
            ],
          },
        ] as Content[];
      },
      pageBreakBefore: function (currentNode) {
        if (currentNode.pageBreak) return true;
        return false;
      },
      content: [mainBody],
      styles: {
        margintop: {
          margin: [0, 2, 0, 2],
        },
        header: {
          fontSize: 14,
          bold: true,
        },
        subheader: {
          fontSize: 10,
          bold: false,
        },
        aspekt: {
          fontSize: 8,
          bold: false,
        },
        footer: {
          fontSize: 8,
          bold: false,
          margin: [0, 0, 80, 20],
        },
        color: {
          margin: [0, 0, 0, 0],
          fillColor: '#2361AE',
        },
        bold: {
          fontSize: 12,
          bold: true,
        },
        unterschrift: {
          fontSize: 12,
          bold: true,
        },
        normal: {
          fontSize: 12,
          bold: false,
        },
        prozent: {
          fontSize: 10,
          bold: true,
          color: '#000000',
        },
        kopf: {
          margin: [0, 5, 0, 15],
        },
        plan: {
          margin: [0, 5, 0, 15],
        },
        mandant: {
          fontSize: 12,
        },
        keineAngabe: {
          fontSize: 10,
          italics: true,
          bold: false,
        },
      },
    };
    return docDefinition;
  }
    private async generateAudits(safetyform: SafetyPointFormModelView, completdForm: CompletedFormDto,formfelderlist:any[]){
        var body = []
        var user = this.UserList.find(x=>x.UserID == safetyform.UserID)
        var Name = "";
        if(user){
          if(user.FirstName || user.LastName){
              Name = user.FirstName +" "+user.LastName;
          }else{
              Name = user.Email;
          }
        }
          const stack1 ={ 
              stack:[
                  {
                      columns:[
                        {
                            text: "Erledigt von "+Name+ " am " + this.datePipe.transform(safetyform.CreatedOn,"dd.MM.yyyy HH:mm"),
                            alignment: 'left',
                            margin: [0, 0, 0, 0],
                            decoration: 'underline'
                        }
                      ]
                }                            
          ]  
        }
        body.push(JSON.parse(JSON.stringify(stack1)));
        for(var i =0; i<completdForm.CompletedFormFieldList.length; i++) {
             var element = completdForm.CompletedFormFieldList[i];
            var found = formfelderlist.find(x=>x.FormFieldId == element.FormFieldId)
            if(found.FormFieldTypeId == FormFieldTypeEnum.Currency || found.FormFieldTypeId == FormFieldTypeEnum.Number|| found.FormFieldTypeId == FormFieldTypeEnum.Text){
                const o1 = {text:found.Name +": "+element.Value}
                body.push(o1)
            }
            if(found.FormFieldTypeId == FormFieldTypeEnum.Date){
                const o1 = {text:found.Name +": "+ this.datePipe.transform(element.Value,"dd.MM.yyyy")}
                body.push(o1)
            }
            if(found.FormFieldTypeId == FormFieldTypeEnum.Link){
                  const o1 = {
                      stack :[
                          {
                              columns:[
                                {
                                    text: found.Name + ": ",
                                    alignment: 'left',
                                    width: 'auto'                                  
                                },            
                                {
                                  text: element.Value,
                                  link:element.Value,
                                  color:'blue',
                                  alignment: 'left'                                  
                                }
                              ]
                          }
                      ] 
                  }

                body.push(o1)
            }
            if(found.FormFieldTypeId == FormFieldTypeEnum.Document){
                var dokuments = await this.dokumenteService.getFilteredList({DataTypeID : datatype.CompletedFormField, DataID: element.CompletedFormFieldId});                
                var cols = [];
                var src = this.GetWhiteImage();
                var metaString = "";                
                if (dokuments.length>0) {
                    var dokument = dokuments[0];                    
                    if(dokument.MetaData){
                        var metaObj = JSON.parse(dokument.MetaData);
                        if(metaObj.CreatedOn){
                            metaString = this.languageService.getText(this.language.Erstellt)+": "+ this.datePipe.transform(new Date(metaObj.CreatedOn),"dd.MM.yyyy HH:mm");
                        }
                    }
                  src = dokument.Src.toString(); 
                  var c3 = {
                    stack :[
                        {
                            columns:[
                              {
                                  text: found.Name,
                                  alignment: 'left',
                                  margin: [0, 15, 0, 5]
                              }
                            ]
                        },            
                        {
                            columns:[
                              {
                                  image: src,
                                  fit: [200, 200],
                                  alignment: 'left',
                                  margin: [0, 15, 0, 5]
                              }
                            ]
                        },
                        {
                            columns:[
                              {
                                  text: metaString,
                                  alignment: 'left',
                                  margin: [0, 5, 0, 5],
                                  fontSize:9
                              }
                            ]
                        }                          
                    ], 
                    unbreakable: true
                  }
                  c3 = JSON.parse(JSON.stringify(c3));
                  cols.push(c3);
                  body.push({ columns: cols });
                  }
             }
        } 
        return body;
    }
    public GetWhiteImage() {
      // return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAACqElEQVR4Xu3SsQ0AMAzDsOb/o1OgN1QbfYAHgbO7e0yBzwUGrM9F3b0CYIGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ2CxUBSAKwkq1OwGEgKgJVkdQoWA0kBsJKsTsFiICkAVpLVKVgMJAXASrI6BYuBpABYSVanYDGQFAAryeoULAaSAmAlWZ1eEqpWXfdMaa4AAAAASUVORK5CYII="';
      return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAABuCAYAAADMK0rsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFMSURBVHhe7dIhDsMwAARBu/9/Zv5Q6HIjq9qARDPSkcM7v9dcg2ebc3866yyPz37AP4REQkgkhERCSCSEREJIJIREQkhvsNYYa9yzQ0J6jb2AameEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIREQkgkhERCSCSEREJIJIRE4gf1ZjOJ+kcdMwAAAABJRU5ErkJggg==';
    }

}